import z, { ZodSchema } from "zod";

export type SearchQueryParams = NodeJS.Dict<string | string[]>;
// TODO: maybe dont need this below
// | { [key: string]: string | string[] };

const parseQueryParamsFromString = (search: string): SearchQueryParams => {
  const params = new URLSearchParams(search);
  const queryParams: SearchQueryParams = {};

  for (const [key, value] of params.entries()) {
    if (queryParams[key]) {
      if (Array.isArray(queryParams[key])) {
        (queryParams[key] as string[]).push(value);
      } else {
        queryParams[key] = [queryParams[key] as string, value];
      }
    } else {
      queryParams[key] = value;
    }
  }

  return queryParams;
};

export function getUrlSearchParams<Schema extends ZodSchema>(
  queryParams: string | SearchQueryParams,
  schema: Schema,
): z.infer<Schema> | null {
  const searchParams =
    typeof queryParams === "string"
      ? parseQueryParamsFromString(queryParams)
      : queryParams;

  const parseResult = schema.safeParse(searchParams);

  if (parseResult.success) {
    return parseResult.data as z.infer<Schema>;
  }

  return null;
}
